<cx-global-message
  aria-atomic="true"
  aria-live="assertive"
  style="width: auto"
  [isInnerHtmlEnable]="true"
  class="cart-disclaimer-msg"
></cx-global-message>

<div class="cart-address-details">
  <span class="cart-header d-flex justify-content-center">{{
    "cart.title" | cxTranslate
  }}</span>
  <form [formGroup]="form" class="d-flex flex-row">
    <div class="cart-details-content">
      <div class="row p-4 m-0">
        <div
          class="cart-details-column col-sm-12 col-md-4 col-lg-4 d-flex flex-column"
        >
          <span class="label-content">{{ "cart.poNumber" | cxTranslate }}</span>
          <input
            required="true"
            type="text"
            class="form-control ponumber-input"
            formControlName="ponumber"
            value="ponumber"
            max="20"
            maxlength="20"
          />
        </div>
        <div
          class="cart-details-column col-sm-12 col-md-4 col-lg-4 d-flex flex-column"
        >
          <span class="label-content">{{
            "cart.shippingAddress" | cxTranslate
          }}</span>
          <div class="ship-to-address">
            <ng-select
              formControlName="address"
              (change)="selectAddress($event)"
              bindLabel="address"
              [searchable]="false"
              [clearable]="false"
            >
              <ng-option
                *ngFor="let address of shippingAddressList"
                [ngValue]="address"
                [value]="address"
              >
                <span>{{ address.formattedAddress }}</span>
              </ng-option>
            </ng-select>
            <div class="selected-address">
              <span>{{
                displaySelectedAddress?.companyName
                  ? displaySelectedAddress?.companyName
                  : orgUnitName
              }}</span>
              <span>{{ displaySelectedAddress?.line1 }}</span>
              <span>{{ displaySelectedAddress?.line2 }}</span>
              <span
                >{{ displaySelectedAddress?.town }},
                {{ displaySelectedAddress?.postalCode }}</span
              >
              <span>{{ displaySelectedAddress?.country?.name }}</span>
            </div>
          </div>
        </div>
        <div
          class="cart-details-column col-sm-12 col-md-4 col-lg-4 d-flex flex-column"
        >
          <span class="label-content">{{
            "cart.requiredDeliveryDate" | cxTranslate
          }}</span>
          <input
            type="text"
            placeholder="Datepicker"
            class="form-control"
            [datesDisabled]="disabledDates"
            bsDatepicker
            formControlName="nominatedDays"
            [bsConfig]="{ selectFromOtherMonth: true }"
          />
          <i class="fa fa-calendar cartcalendar" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </form>
</div>
